/** @format */
import React, { useEffect, useState } from "react";
import { Switch, Route, Link, useLocation } from "react-router-dom";

import "./css/styles.css";
import { BiSearchAlt2 } from "react-icons/bi";

import { motion, AnimatePresence } from "framer-motion";
import loadable from "@loadable/component";
import axios from "axios";
import queryString from "query-string";

const Images = loadable(() => import("./components/main/Images"));
const Search = loadable(() => import("./components/main/Search"));
const Result = loadable(() => import("./components/main/Result"));
const Sidebar = loadable(() => import("./components/sidebar/Sidebar"));
const Person = loadable(() => import("./components/person/Person"));
const Login = loadable(() => import("./components/Signup/Login"));
const Register = loadable(() => import("./components/Signup/Register"));
const UserProfile = loadable(() =>
  import("./components/userprofile/UserProfile")
);
const Useruploads = loadable(() => import("./components/Useruploads"));
const Edit = loadable(() => import("./components/Edit/Edit"));

function App() {
  const [userDetails, setUserDetails] = useState("");

  const location = useLocation();
  const transD = {
    duration: 1,
    transition: "linear",
    type: "tween",
    ease: "easeIn",
  };
  let data = location.state && location.state.value;
  useEffect(() => {
    if (location.search) {
      let query = queryString.parse(location.search);

      localStorage.setItem("token", query.user);
      fetchData();
    }
  }, []);

  useEffect(() => {
    fetchUserDetails();
  }, [data]);

  const fetchUserDetails = async () => {
    let token = localStorage.getItem("token");
    axios
      .get("https://shielded-sierra-36025.herokuapp.com/userdetails", {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data) setUserDetails(res.data.value);
      })
      .catch((err) => {
        setUserDetails("");
      });
  };
  const fetchData = async () => {
    const token = localStorage.getItem("token");

    axios
      .get("https://shielded-sierra-36025.herokuapp.com/userdetails", {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data) setUserDetails(res.data.value);
      })
      .catch((err) => {
        setUserDetails("");
      });
  };
  return (
    <AnimatePresence exitBeforeEnter>
      <Switch location={location} key={location.pathname}>
        <Route path="/" exact>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={transD}
            className="main-container">
            <div className="main-contents">
              <>
                <Sidebar data={userDetails} />
              </>
              <div className="nav-bar">
                <Link to="/photos/search">
                  <BiSearchAlt2 className="search-icon" />
                </Link>
              </div>
              <div>
                <Images />
              </div>
            </div>
          </motion.div>
        </Route>

        <Route path="/photos/search" exact>
          <Search />
        </Route>
        <Route path="/result" exact>
          <Result data={userDetails} />
        </Route>
        <Route path="/person/:id" exact>
          <Person />
        </Route>
        <Route path="/user/:id" exact>
          <UserProfile data2={userDetails} />
        </Route>
        <Route path="/login" exact>
          <Login />
        </Route>
        <Route path="/register" exact>
          <Register />
        </Route>
        <Route path="/uploads" exact>
          <Useruploads data2={userDetails} />
        </Route>
        <Route path="/edit/:id" exact>
          <Edit />
        </Route>
      </Switch>
    </AnimatePresence>
  );
}

export default App;
